import $ from 'jquery';

export default function gettingHereMaps (vars){

	if (typeof getting_there_methods === 'undefined') {
		return;
	}

	var $tabs = $('#getting-here-tabs');

	if (!$tabs.length) {
		return;
	}
	var mapMarkerBaseUrl = (typeof base_url !== 'undefined')
		? base_url + 'patterns/public/assets/img/map-ico/'
		: '/assets/img/map-ico/';

	// method_stub -> { map, center }
	var loadedMaps = {};

	// Advanced Markers need the 'marker' library and a Map ID on the map.
	// DEMO_MAP_ID is Google's placeholder for development; set a real Map ID
	// (Google Cloud Console > Map Management) per method via `map_id`, or
	// replace the fallback below, before going live.
	var defaultMapId = 'DEMO_MAP_ID';
	var markerLibraryPromise = google.maps.importLibrary('marker');

	/**
	 * Resolve the icon filename for a transport marker.
	 */
	function resolveMarkerIconUrl(methodConfig, markerConfig) {
		var iconName = markerConfig.marker_icon;

		if (iconName === 'auto') {
			iconName = (methodConfig.method_stub === 'by-car')
				? 'parking'
				: methodConfig.method_stub;
		}

		return mapMarkerBaseUrl + iconName + '.png';
	}

	/**
	 * Build the DOM element used as an Advanced Marker's icon.
	 */
	function createMarkerContent(iconUrl) {
		var img = document.createElement('img');
		img.src = iconUrl;
		img.alt = '';
		return img;
	}

	/**
	 * Build (once) the Google Map, venue marker, and transport markers
	 * for a given method_stub.
	 */
	function buildMap(methodStub, methodConfig, $canvas) {
		var venueLatLng = new google.maps.LatLng(methodConfig.venue_lat, methodConfig.venue_lng);
		var centerLatLng = new google.maps.LatLng(methodConfig.center_lat, methodConfig.center_lng);

		var map = new google.maps.Map($canvas[0], {
			zoom: methodConfig.zoom,
			center: centerLatLng,
			mapId: methodConfig.map_id || defaultMapId,
			scrollwheel: false,
			mapTypeControl: false,
			streetViewControl: false,
			panControl: true,
			mapTypeId: methodConfig.map_type
		});

		// Register straight away so repeat calls refresh instead of rebuilding;
		// the markers are added once the marker library has loaded.
		loadedMaps[methodStub] = {
			map: map,
			center: centerLatLng
		};

		markerLibraryPromise.then(function (markerLibrary) {
			var AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;

			// Venue marker.
			new AdvancedMarkerElement({
				position: venueLatLng,
				map: map,
				title: methodConfig.venue_name,
				content: createMarkerContent(mapMarkerBaseUrl + methodConfig.venue_internal_slug + '.png')
			});

			// Transport location markers.
			var transportMarkers = methodConfig.markers || [];
			for (var i = 0; i < transportMarkers.length; i++) {
				var markerConfig = transportMarkers[i];

				new AdvancedMarkerElement({
					position: new google.maps.LatLng(markerConfig.lat, markerConfig.lng),
					map: map,
					title: markerConfig.marker_title,
					content: createMarkerContent(resolveMarkerIconUrl(methodConfig, markerConfig))
				});
			}
		});

		// Force Maps to re-measure the container now that it's actually laid out,
	    // otherwise the first-built map (the initially active tab) can end up
	    // sized/tiled against a stale or zero-size container.
	    google.maps.event.addListenerOnce(map, 'idle', function () {
	        google.maps.event.trigger(map, 'resize');
	        map.setCenter(centerLatLng);
	    });
	}

	/**
	 * Load (first time) or refresh (subsequent times) the map for a tab.
	 */
	function loadMapFor(methodStub, lastSeenHeight, attemptsLeft) {
		var methodConfig = getting_there_methods[methodStub];
		if (!methodConfig) {
			return;
		}

		var $canvas = $tabs.find('#map-canvas-' + methodStub);

		if (!$canvas.length) {
			return;
		}

		var existing = loadedMaps[methodStub];

		if (!existing) {
			// Building a Google Map inside a container that isn't at its
			// final size yet (e.g. zero-size before layout has settled)
			// leaves it permanently blank; triggering 'resize' afterwards
			// doesn't recover it. So wait for the container's size to stop
			// changing before constructing the map, instead of building
			// then fixing.
			//
			// .tab__map's height comes from the padding-bottom aspect-ratio
			// technique (see the ratio() mixin in _mixins.scss), so jQuery's
			// box-model-aware .height()/.width() (which exclude padding)
			// always read 0 here — use the element's actual rendered box
			// (offsetWidth/offsetHeight) instead.
			var canvasEl = $canvas[0];
			var currentHeight = canvasEl.offsetHeight;

			if (typeof attemptsLeft === 'undefined') {
				attemptsLeft = 40;
			}

			if (!canvasEl.offsetWidth || !currentHeight || currentHeight !== lastSeenHeight) {
				if (attemptsLeft > 0) {
					setTimeout(function () {
						loadMapFor(methodStub, currentHeight, attemptsLeft - 1);
					}, 50);
				}
				return;
			}

			buildMap(methodStub, methodConfig, $canvas);
			return;
		}

		// Already built: just make sure it re-renders correctly (e.g. after
		// being hidden/shown or the window resizing) instead of rebuilding.
		google.maps.event.trigger(existing.map, 'resize');
		existing.map.setCenter(existing.center);
	}

	function getActiveMethodStub() {
		var $checkedInput = $tabs.find('.tabs__input:checked');
		if (!$checkedInput.length) {
			return null;
		}
		return $checkedInput.val();
	}

	function debounce(fn, waitMs) {
		var timeoutId;
		return function () {
			var context = this, args = arguments;
			clearTimeout(timeoutId);
			timeoutId = setTimeout(function () {
				fn.apply(context, args);
			}, waitMs);
		};
	}

	// Load the map for whichever tab starts active.
	var initialStub = getActiveMethodStub();
	if (initialStub) {
		loadMapFor(initialStub);
	}

	// Load/refresh the map when a tab is selected. The tabs themselves are
	// pure CSS (radio inputs + :checked) — this only lazily loads each map
	// the first time its tab becomes active.
	$tabs.on('change', '.tabs__input', function () {
		loadMapFor(this.value);
	});

	// Refresh the currently active map on resize (debounced).
	$(window).on('resize', debounce(function () {
		var activeStub = getActiveMethodStub();
		if (activeStub) {
			loadMapFor(activeStub);
		}
	}, 200));
}